module.exports = __webpack_public_path__ + "static/media/30Bar.ece847f0.svg";